export const initialState = () => ({
  listOptionsOffers: [],
  rulesOffers: {
    hasToFech: true
  },
  offersSelecteds: [],
  paramsFilter: {},
  filterCampaignSelecteds: []
})
